import styled from '@emotion/styled';
import { spacing, palette, borderRadius, breakpoints } from 'theme';

export const OppTraining = styled.div({
  marginTop: spacing[12],
  paddingBlock: spacing[4],
  paddingInline: spacing[8],
  border: '1px solid',
  borderColor: palette.primary[300],
  borderRadius: borderRadius.lg,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',

  '& > .training__text': {
    flex: '1 1 100%',
  },

  '& > .training__badge + .training__badge': {
    '&::before': {
      content: "''",
      height: '4px',
      width: '4px',
      marginInline: spacing[4],
      backgroundColor: palette.primary[700],
      borderRadius: borderRadius.full,
    },
  },

  [`${breakpoints.mobile}`]: {
    width: 'fit-content',
    '& > .training__text': {
      flex: '0 1 auto',
      marginRight: spacing[12],
    },
  },
});
